export const COUNTRIES = {
  AU: 'Australia',
  NZ: 'New Zealand',
};

/**
 * Returns a combined address string representing multiple address fields.
 *
 * Required address fields:
 *  address2 (eg, Unit 204)
 *  streetNumber (eg, 37 or 37-39)
 *  address (eg, Bank Road)
 *  suburb (eg, Homebush)
 *  postCode (eg, 2040)
 *  state (eg, NSW or New South Wales)
 *  countryCode (eg, AU or Australia)
 *
 * @param {Object} givenAddress Address fields
 * @returns {string} A string representation of the full address
 */
export default (givenAddress = {}) => {
  const addr = {
    ...givenAddress,
    address2: givenAddress.address2 || '',
  };

  const displayCountry = COUNTRIES[addr.countryCode] ? COUNTRIES[addr.countryCode] : addr.countryCode;

  const commaSeparated = [addr.address, addr.suburb, addr.state, addr.postCode, displayCountry].filter(Boolean).join(', ');

  const spaceSeparated = [addr.address2, addr.streetNumber, commaSeparated].filter(Boolean).join(' ');

  return spaceSeparated.trim();
};
